// import React from "react";
// import "./VariationCard.css";
// const VariationCard = ({ v }) => (
//   <div className="variation_grid">
//     <div className="Variation_Card" key={v._id}>
//       <h3 className="variation_title">{v.variationName}</h3>

//       <div className="variation_image_wrapper">
//         <img src={v.image} alt={v.variationName} />
//       </div>

//       <h3>
//         Sanskrit: <span className="answer">{v.sanskrit}</span>
//       </h3>
//       <h3>
//         English: <span className="answer">{v.english}</span>
//       </h3>
//       <h3>
//         Pose Type: <span className="answer">{v.poseType}</span>
//       </h3>
//       <h3>
//         Name: <span className="answer">{v.name}</span>
//       </h3>
//       <h3>
//         Country: <span className="answer">{v.country}</span>
//       </h3>

//       <h3>
//         Media Link :{" "}
//         <a href={v.mediaLink} className="answer">
//           {v.mediaLink}
//         </a>
//       </h3>
//     </div>
//   </div>
// );

// export default VariationCard;

import React from "react";
import "./VariationCard.css";

const VariationCard = ({ v }) => {
  return (
    <div className="variation_grid">
      <div className="Variation_Card">
        <h3 className="variation_title">{v.name}</h3>

        <div className="variation_image_wrapper">
          <img
            src={
              v?.image &&
              (v.image.startsWith("http") || v.image.startsWith("blob:"))
                ? v.image
                : "/no-image.png"
            }
            alt={v?.name || "variation"}
            loading="lazy"
          />
        </div>

        <h3>
          Sanskrit: <span className="answer">{v.sanskrit}</span>
        </h3>

        <h3>
          English: <span className="answer">{v.english}</span>
        </h3>

        <h3>
          Pose Type: <span className="answer">{v.poseType}</span>
        </h3>

        <h3>
          Name: <span className="answer">{v.name}</span>
        </h3>

        <h3>
          Country: <span className="answer">{v.country}</span>
        </h3>

        <h3>
  Media Link :{" "}
  {v.mediaLinkStatus === "expired" || !v.mediaLink ? (
    <span style={{ color: "red" }}>Expired</span>
  ) : (
    <a href={v.mediaLink} target="_blank" rel="noreferrer">
      {v.mediaLink}
    </a>
  )}
</h3>
      </div>
    </div>
  );
};

export default VariationCard;
